import { X, Bot, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface ProactiveSuggestion {
  id: string
  type: 'overdue' | 'unassigned' | 'workload'
  title: string
  description: string
  actionLabel: string
  onAction: () => void
}

interface ProactiveCardProps {
  suggestion: ProactiveSuggestion
  onDismiss: (id: string) => void
}

export function ProactiveCard({ suggestion, onDismiss }: ProactiveCardProps) {
  return (
    <div
      className={cn(
        'relative flex items-start gap-3 p-3 rounded-lg',
        'border-l-2 border-primary/60 bg-[var(--agent-surface-alpha)]',
        'animate-in slide-in-from-top-1 duration-200',
      )}
    >
      {/* Agent icon */}
      <div className="flex-shrink-0 mt-0.5">
        <div className="h-7 w-7 rounded-full bg-primary/10 flex items-center justify-center">
          <Bot className="h-3.5 w-3.5 text-primary" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-[10px] font-medium px-1.5 py-0.5 rounded bg-gradient-to-r from-primary/10 to-[hsl(280,100%,70%)]/10 text-primary">
            Agent suggestion
          </span>
        </div>
        <p className="text-sm font-medium">{suggestion.title}</p>
        <p className="text-xs text-muted-foreground mt-0.5">{suggestion.description}</p>
        <div className="flex items-center gap-2 mt-2">
          <Button
            variant="outline"
            size="sm"
            className="h-7 text-xs gap-1"
            onClick={suggestion.onAction}
          >
            {suggestion.actionLabel}
            <ArrowRight className="h-3 w-3" />
          </Button>
        </div>
      </div>

      {/* Dismiss */}
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6 flex-shrink-0"
        onClick={() => onDismiss(suggestion.id)}
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
